import { render, staticRenderFns } from "./middlejiao.vue?vue&type=template&id=1f80c92c&scoped=true&"
import script from "./middlejiao.vue?vue&type=script&lang=js&"
export * from "./middlejiao.vue?vue&type=script&lang=js&"
import style0 from "./middlejiao.vue?vue&type=style&index=0&id=1f80c92c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f80c92c",
  null
  
)

export default component.exports